import React, { Suspense } from 'react'
import PropTypes from 'prop-types'
import { Switch, Route } from 'react-router-dom'

// Components
import Loading from 'src/Components/shared/Loading/LoadingApp'

// Routes
import LazyRoutes from '../LazyRoutes'

const Chromebot = ({ match }) => {
  return (
    <Suspense fallback={<Loading />}>
      <Switch>
        <Route path={match.url} component={LazyRoutes.Chromebot} />
      </Switch>
    </Suspense>
  )
}

Chromebot.propTypes = {
  match: PropTypes.shape({
    url: PropTypes.string
  })
}

export default Chromebot
